var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject } from "~/core/decorator";
var OutsourcePerformanceService = /** @class */ (function () {
    function OutsourcePerformanceService() {
    }
    /**
     * 委外管理-委外业绩查询-委外批次业绩
     */
    OutsourcePerformanceService.prototype.queryCaseOutBathList = function (data, page, sort) {
        return this.netService.send({
            server: domainService.outsourcePerformanceManageController.queryCaseOutBathList,
            data: data,
            page: page,
            sort: sort,
        });
    };
    /**
     * 委外管理-委外业绩查询-money
     */
    OutsourcePerformanceService.prototype.queryCaseOutMoneyList = function (data, page, sort) {
        return this.netService.send({
            server: domainService.outsourcePerformanceManageController.queryCaseOutMoneyList,
            data: data,
            page: page,
            sort: sort,
        });
    };
    /**
     * 委外管理-委外业绩查询-委外产品业绩
     */
    OutsourcePerformanceService.prototype.queryCaseOutProductList = function (data, page, sort) {
        return this.netService.send({
            server: domainService.outsourcePerformanceManageController.queryCaseOutProductList,
            data: data,
            page: page,
            sort: sort,
        });
    };
    /**
     * 委外管理-委外业绩查询-批次号
     */
    OutsourcePerformanceService.prototype.queryOutBatchList = function (data) {
        return this.netService.send({
            server: domainService.outsourcePerformanceManageController.queryOutBatchList,
            data: data,
        });
    };
    __decorate([
        Inject(NetService)
    ], OutsourcePerformanceService.prototype, "netService", void 0);
    return OutsourcePerformanceService;
}());
export { OutsourcePerformanceService };
